import { render } from "./delegation_of_authority.html?vue&type=template&id=6095d5ec&external"
import script from "./delegation_of_authority.js?vue&type=script&lang=js&external"
export * from "./delegation_of_authority.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__